
<!--
/**
  * 多级表头嵌套
  * @author mayu
  * @date 2023-06-20
  */
-->
<template>
  <el-table-column 
    :align="coloumnHeader.align || 'center'"
    :width="coloumnHeader.width"
    :label="coloumnHeader.label" 
    :prop="coloumnHeader.value"
    :fixed="coloumnHeader.fixed"
    header-align="center"
    :show-overflow-tooltip="coloumnHeader.tooltip==false?false:true"
    :sortable="coloumnHeader.sortable||false"
  >
    <template v-for="item in coloumnHeader.children">
      <EXTableColumn
        v-if="item.children && item.children.length"
        :align="item.align || 'center'"
        :key="item.value"
        :width="item.width"
        header-align="center"
        :fixed="item.fixed"
        :show-overflow-tooltip="item.tooltip==false?false:true"
        :sortable="item.sortable||false"
        :coloumn-header="item"
      ></EXTableColumn>
      <el-table-column
        v-else
        :prop="item.value"
        :align="item.align || 'center'"
        :width="item.width"
        :key="item.value"
        :label="item.label"
        header-align="center"
        :fixed="item.fixed"
        :show-overflow-tooltip="item.tooltip==false?false:true"
        :sortable="item.sortable||false"
      >
      </el-table-column>
    </template>
  </el-table-column>
</template>
 
<script>
export default {
  name: "EXTableColumn",
  props: {
    coloumnHeader: {
      type: Object,
      required: true,
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/EXTable/EXTableColumn.vue